export const influencersPath = {
  /* inject path */
  WORK_EXPERIENCES: '/influencers/work-experiences/:id?/:name',
  WORK_EXPERIENCES_URI: '/influencers/work-experiences',
  EDUCATIONS: '/influencers/educations/:id?/:name',
  EDUCATIONS_URI: '/influencers/educations',
  CONVERSATIONS: '/influencers/conversations/:id?/:firstname?/:secondname?',
  CONVERSATIONS_URI: '/influencers/conversations',
  RELATION_MAP: '/influencers/relation-map/:relatedType?/:id/:name',
  LOCATION_HISTORY: '/influencers/location-history',
  INFLUENCER_SENTIMENT_ANALYSIS:
    '/influencers/influencer-sentiment-analysis/:id/:name',
  INFLUENCER_SENTIMENT_ANALYSIS_URI:
    '/influencers/influencer-sentiment-analysis',
  EDIT_CATEGORY: '/influencers/edit-category/:id',
  EDIT_CATEGORY_URI: '/influencers/edit-category',
  EDIT_GROUP: '/influencers/edit-group/:id',
  EDIT_GROUP_URI: '/influencers/edit-group',
  INF_SUBCATEGORY: '/influencers/categories/all/:id/:name',
  INF_SUBCATEGORY_URI: '/influencers/categories/all',
  ADD_NEW_CATEGORY: '/influencers/add-new-category',
  ADD_NEW_GROUP: '/influencers/add-new-group',
  EDIT_INFLUENCER: '/influencers/edit-influencer/:id',
  EDIT_INFLUENCER_URI: '/influencers/edit-influencer',
  ADD_NEW_INFLUENCER: '/influencers/add-new-influencer',
  ANALYZED_INFLUENCER_DETAILS: '/influencers/analyzed-influencer-details/:id',
  ANALYZED_INFLUENCER_DETAILS_URI: '/influencers/analyzed-influencer-details',

  UN_ANALYZED_INFLUENCER_DETAILS:
    '/influencers/unanalyzed-influencer-details/:id',
  UN_ANALYZED_INFLUENCER_DETAILS_URI:
    '/influencers/unanalyzed-influencer-details',

  INFLUENCERS_CATEGORIES: '/influencers/categories/all',
  INFLUENCERS_GROUP: '/influencers/influencers-groups',
  NEW_INFLUENCERS: '/influencers/new-influencers',
  INFLUENCERS: '/influencers/influencers',
  ALL: '/influencers/all',
  INFLUENCER_CATEGORIES_GROUPS_HASHTAGS: '/influencers/hashtags',
  INFLUENCER_CATEGORIES_GROUPS_TOP_POSTS: '/influencers/top-posts/:name/:id',
  INFLUENCER_CATEGORIES_GROUPS_TOP_POSTS_URI: '/influencers/top-posts',
  ANALYZED_INFLUENCER_LOCATION_HISTORY: '/influencers/location-history/:id',
  ANALYZED_INFLUENCER_LOCATION_HISTORY_URI: '/influencers/location-history',
  //group routes
  INFLUENCER_ITEMS_To_GROUP: '/influencers/groups/items-to-group/:name/:id',
  INFLUENCER_ITEMS_To_GROUP_URI: '/influencers/groups/items-to-group',
  INFLUENCER_GROUP_DETAILS: '/influencers/groups/group-details/:id',
  INFLUENCER_GROUP_DETAILS_URI: '/influencers/groups/group-details',
  //related
  INFLUENCER_RELATED_INFLUENCERS: '/influencers/related-influencers/:id/:name',
  INFLUENCER_RELATED_INFLUENCERS_URI: '/influencers/related-influencers',
  INFLUENCER_RELATED_ENTITIES: '/influencers/related-entities/:id/:name',
  INFLUENCER_RELATED_ENTITIES_URI: '/influencers/related-entities',
};
export const entitiesPath = {
  /* inject path */
  WORK_EXPERIENCES: '/entities/work-experiences/:id?/:name',
  WORK_EXPERIENCES_URI: '/entities/work-experiences',
  RELATION_MAP: '/entities/relation-map/:relatedType?/:id/:name',
  ENTITIES_SENTIMENT_ANALYSIS: '/entities/entity-sentiment-analysis/:id/:name',
  ENTITIES_SENTIMENT_ANALYSIS_URI: '/entities/entity-sentiment-analysis',
  ENTITIES_CATEGORIES_GROUPS_HASHTAGS: '/entities/hashtags',
  ENTITIES_CATEGORIES_GROUPS_TOP_POSTS: '/entities/top-posts/:name/:id',
  ENTITIES_CATEGORIES_GROUPS_TOP_POSTS_URI: '/entities/top-posts',
  EDIT_CATEGORY: '/entities/edit-category/:id',
  EDIT_CATEGORY_URI: '/entities/edit-category',
  EDIT_GROUP: '/entities/edit-group/:id',
  EDIT_GROUP_URI: '/entities/edit-group',
  INF_SUBCATEGORY: '/entities/categories/all/:id/:name',
  Entity_SUBCATEGORY_URI: '/entities/categories/all',
  ADD_NEW_CATEGORY: '/entities/add-new-category',
  ADD_NEW_GROUP: '/entities/add-new-group',
  EDIT_ENTITIES: '/entities/edit-entity/:id',
  EDIT_ENTITIES_URI: '/entities/edit-entity',
  ADD_NEW_ENTITIES: '/entities/add-new-entity',
  ANALYZED_ENTITIES_DETAILS: '/entities/analyzed-entity-details/:id',
  ANALYZED_ENTITIES_DETAILS_URI: '/entities/analyzed-entity-details',

  ANALYZED_ENTITIES_LOCATION_HISTORY: '/entities/location-history/:id',
  ANALYZED_ENTITIES_LOCATION_HISTORY_URI: '/entities/location-history',

  UN_ANALYZED_ENTITIES_DETAILS: '/entities/unanalyzed-entity-details/:id',
  UN_ANALYZED_ENTITIES_DETAILS_URI: '/entities/unanalyzed-entity-details',

  ENTITIES_CATEGORIES: '/entities/categories/all',
  ENTITIES_GROUP: '/entities/entities-groups',
  NEW_ENTITIES: '/entities/new-entities',
  ENTITIES: '/entities/entities',
  ALL: '/entities/all',

  //group routes
  ENTITIES_ITEMS_To_GROUP: '/entities/groups/items-to-group/:name/:id',
  ENTITIES_ITEMS_To_GROUP_URI: '/entities/groups/items-to-group',
  ENTITIES_GROUP_DETAILS: '/entities/groups/group-details/:id',
  ENTITIES_GROUP_DETAILS_URI: '/entities/groups/group-details',
  //related
  ENTITIES_RELATED_INFLUENCERS: '/entities/related-influencers/:id/:name',
  ENTITIES_RELATED_INFLUENCERS_URI: '/entities/related-influencers',
  ENTITIES_RELATED_ENTITIES: '/entities/related-entities/:id/:name',
  ENTITIES_RELATED_ENTITIES_URI: '/entities/related-entities',
  CONVERSATIONS: '/entities/conversations/:id?/:firstname?/:secondname?',
  CONVERSATIONS_URI: '/entities/conversations',
};
